module finadai.app.admin.create_reference {
    import ProxyRecord = models.http.responses.ProxyRecord;
    export var NAME = "finadai.app.admin.create_reference"

    function AdminCreateReferenceController(customersService: services.CustomersService,
                                            whoIAm: models.User, $rootScope, $scope,
                                            notify, confirm, $mdDialog: ng.material.IDialogService,
                                            $state: ng.ui.IStateService, negotiationsService: services.NegotiationsService,
                                            proxifier, $q: ng.IQService, authService: services.AuthService) {

        $scope.formData = {};
        $scope.createReferenceData = {};
        $scope.creatingReference = false;
        $scope.referencesCreated = false;
        $scope.newReferences = "";
        $scope.canCreateReference = whoIAm.operations.indexOf('admin_create_single_reference') >= 0;
        $scope.createReferenceOxxo = (form) => {
            $scope.referencesCreated = false;
            if (form.$valid) {
                $scope.creatingReference = true;
                customersService.proxyCreateReferenceAdmin({
                    customer_number: $scope.createReferenceData.customer_number,
                    amount: $scope.createReferenceData.amount
                })
                    .then(function (response) {
                        console.log(response.data);
                        $scope.references = response.data;
                        let $data_reference = "<ul>";
                        angular.forEach($scope.references.Data, function (value, key) {
                            $data_reference += "<li>" + value["Reference"] + " - $" + value["Amount"] + "</li>";
                        });
                        $data_reference += '</ul>';
                        $data_reference += '<hr />';

                        $scope.newReferences = $data_reference;
                        $scope.creatingReference = false;
                        $scope.referencesCreated = true;
                    }, function () {
                        $scope.creatingReference = false;
                    })

            }
        };
    }

    export function run() {
        var find = angular.module(NAME, [])
        find.controller("AdminCreateReferenceController", AdminCreateReferenceController)
    }
}
finadai.app.admin.create_reference.run();
